/*
 * @Author: zhenhui.duan
 * @Date: 2024-05-14 18:00:25
 * @Description:
 */
import React, { Suspense } from 'react';

import config from '../config';

const Loading = () => {
  return null;
};

const MarketList = React.lazy(() => {
  return import('_common_old/containers/Market');
});
const SpotInfo = React.lazy(() => {
  return import('_common_old/containers/SpotInfo');
});

const RouteMap = [
  {
    path: `/${config.routePrefix}/list`,
    component: () => {
      return (
        <Suspense fallback={<Loading />}>
          <MarketList />
        </Suspense>
      );
    },
    exact: true,
  },
  {
    path: `/${config.routePrefix}/spot-info/:product?`,
    component: () => {
      return (
        <Suspense fallback={<Loading />}>
          <SpotInfo />
        </Suspense>
      );
    },
    exact: true,
  },
  {
    path: `/${config.routePrefix}`,
    redirect: `/${config.routePrefix}/list`,
    exact: true,
  },
  {
    path: `/404`,
    component: () => {
      return <h1>404</h1>;
    },
    exact: false,
  },
];

export default RouteMap;
